import { apiMapper } from "./ApiMapper";
const DASHBOARDAPI = {
  DATA: (axiosPrivate) => {
    return axiosPrivate.get(apiMapper.dashboard.data);
  },

  RESOURCE_INSIGHTS: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.dashboard.resourceInsights, payload);
  },

  CONSULTANTS_LIST: (axiosPrivate, startDate, endDate, filterType, value) => {
    return axiosPrivate.get(
      `${apiMapper.dashboard.consultantsList}?start_date=${startDate}&end_date=${endDate}&filter_type=${filterType}&values=${value}`
    );
  },
  FILTER_BY_CLIENT: (axiosPrivate, startDate, endDate, clientId) => {
    return axiosPrivate.get(
      `${apiMapper.dashboard.consultantsList}?start_date=${startDate}&end_date=${endDate}&filter_type=client&values=${clientId}&group_by=employee`
    );
  },
  GET_CONTRACTS_COUNT: (axiosPrivate) => {
    return axiosPrivate.get(apiMapper.dashboard.getContractsCount);
  },
  GET_ACTIVE_CONTRACTS: (axiosPrivate, order_by) => {
    let url = apiMapper.dashboard.getActiveContracts;
    if (order_by) {
      url += `?order_by=${encodeURIComponent(order_by)}`;
    }
    return axiosPrivate.get(url);
  }
};
export default DASHBOARDAPI;
